export const addSoftHyphens = (text: string): string => {
  // Dictionary of Swedish compound words with soft hyphen positions Using \u00AD for soft hyphen (­)
  // Only lowercase versions needed - case-insensitively will be matched
  const compoundWords: Record<string, string[]> = {
    informationsfullmakt: ["informations", "fullmakt"],
  };

  let result = text;

  const sortedWords = Object.entries(compoundWords).sort(
    ([a], [b]) => b.length - a.length,
  );

  sortedWords.forEach(([word, parts]) => {
    const regex = new RegExp(`\\b${escapeRegex(word)}\\b`, "gi");

    result = result.replace(regex, (match) => {
      const totalPartsLength = parts.reduce(
        (sum, part) => sum + part.length,
        0,
      );

      if (match.length !== totalPartsLength) {
        return match;
      }

      let position = 0;
      return parts
        .map((part) => {
          const preservedPart = preserveCase(
            part,
            match.substring(position, position + part.length),
          );
          position += part.length;
          return preservedPart;
        })
        .join("\u00AD");
    });
  });

  return result;
};

function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function preserveCase(template: string, original: string): string {
  if (!original || !template) return template;

  let result = "";
  for (let i = 0; i < template.length; i++) {
    if (i >= original.length) {
      result += template[i];
      continue;
    }

    const templateChar = template[i];
    const originalChar = original[i];

    if (
      originalChar === originalChar?.toUpperCase() &&
      originalChar !== originalChar?.toLowerCase()
    ) {
      result += templateChar?.toUpperCase();
    } else {
      result += templateChar?.toLowerCase();
    }
  }

  return result;
}
